import React from 'react';
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
} from 'react-router';

import './index.css';

import App from '@/app/App';
import {configureApi} from '@/shared/api/serve/axios';
import PageLoader from '@/shared/components/PageLoader';
import {getToken} from '@/shared/lib/localStorage/getToken';

import AppError from './app/components/AppError';

configureApi({getToken});

export function Layout({children}: {children: React.ReactNode}) {
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <link rel="icon" sizes="192x192" href="/favicon-192.png" />
        <link rel="icon" sizes="128x128" href="/favicon-128.png" />
        <link rel="icon" sizes="32x32" href="/favicon.png" type="image/png" />
        <link rel="icon" sizes="any" href="/favicon.svg" type="image/svg+xml" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/touchicon-180.png"
        />
        <link rel="apple-touch-icon" href="/touchicon.png" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=5"
        />
        <title>Bumpy - International Dating</title>
        <meta
          name="description"
          content="Join over 20 million real users worldwide and find your international soulmate."
        />
        <meta
          name="facebook-domain-verification"
          content="5w28n12dno7irpkzp9clyg5wugr05r"
        />
        <link
          rel="preload"
          href="/fonts/OpenSans-Regular.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/OpenSans-Italic.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function Root() {
  return (
    <App>
      <Outlet />
    </App>
  );
}

export function HydrateFallback() {
  return <PageLoader />;
}

export function ErrorBoundary() {
  const error = useRouteError();

  return <AppError error={error} />;
}
